var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 15
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M.429 13.793L6.864 7.5.429 1.207",
  stroke: "#000",
  fill: "none",
  strokeLinecap: "square"
})));
export default SvgChevronRight;